import Page from "../components/Page";
import BackButton from "../components/BackButton";
import { Badge, Table } from "react-bootstrap";
import ScrollToTop from "../components/ScrollToTop";
import useIsMobile from "../hooks/useIsMobile";
import { patreonUrl } from "../constants";

const Rules = () => {
  const isMobile = useIsMobile();

  return (
    <Page>
      <div className="page-bar">
        <div className="inner">
          <ScrollToTop />
          <div style={{ display: "flex", alignItems: "center" }}>
            <BackButton />
            <h4 className="bar-title">Правила гри (оновлено 18.07.25)</h4>
          </div>
        </div>
      </div>
      <div className="page-offset">
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-patch-question"></i>&nbsp;Як почати грати?
        </h5>
        <p>
          ✅ Зберіть команду з 15 футболістів – 11 основних і 4 заміни. Склад
          має включати 2 голкіперів, 5 захисників, 5 півзахисників і 3
          нападники.
        </p>
        <p>✅ Загальна вартість вашої команди має не перевищувати 100 монет.</p>
        <p>✅ Ви не можете взяти більше 2 футболістів одного клубу.</p>
        <p id="scheme-rules" style={{ scrollMarginTop: 115 }}>
          ✅ Оберіть схему гри. Вона має включати 1 голкіпера, мінімум 3
          захисники, мінімум 2 півзахисники та мінімум 1 нападника. Схему можна
          змінювати кожного туру.
        </p>
        <p>
          ✅ Кожного туру обирайте капітана (К) та віце-капітана (ВК). Очки
          капітана подвоюються. Якщо основний капітан не зіграв, то подвояться
          очки віце-капітана.{" "}
        </p>
        <p>
          ✅ Будьте уважні - усі ваші зміни у складі мають бути підтверджені
          натисканням кнопки «Зберегти». Дедлайн будь-яких змін у складі – за
          1,5 години до початку першого матчу кожного туру.
        </p>
        <p>
          ✅ Один раз за тур ви можете скинути свій склад, тобто повернути його
          до стану минулого туру. При цьому усі зміни, які ви зробили зі складом
          в поточному турі будуть втрачені.
        </p>
        <p>
          ✅ Опція скинути склад не буде доступною підчас турів, коли діятиме
          правило необмеженої кількості трансферів.
        </p>
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-patch-question"></i>&nbsp;Як грати далі?
        </h5>
        <p>
          ✅ Очки для вашої команди набирають основні гравці. Запасні виходять
          на заміну автоматично, якщо основні не зіграли. Польовий запасний
          гравець може замінити будь-якого польового гравця, якщо ця заміна не
          порушує <a href="#scheme-rules">правил схеми гри</a>.
        </p>
        <p>✅ Голкіпер може бути замінений тільки іншим голкіпером.</p>
        <p>
          ✅ Кожного туру ви маєте можливість визначати пріоритет лави запасних,
          тобто вказати порядок - хто з польових футболістів першим стане
          основним. Для цього потрібно натиснути кнопку "Пріоритети" та за
          допомогою кнопок-стрілок налаштувати порядок футболістів на вашій лаві
          запасних. Самий пріоритетний футболіст має вказуватись з цифрою 1,
          найменш пріоритетний - з цифрою 3.
        </p>
        <p>
          ✅ Після кожного туру ви можете зробити заміни і 2 трансфери – продати
          і купити 2 гравців. Перший тур і стартовий тур після зимової паузи –
          кількість трансферів необмежена. Невикористані трансфери зберігаються
          та можуть бути використані у наступних турах.
        </p>{" "}
        <p>
          ✅ Перенесені/недограні матчі будуть прикріплятись до туру перед цим
          матчем. Наприклад, якщо перенесений матч буде зіграно/дограно між 20-м
          і 21-м турами, то він буде прикріплений до 20-го туру.
        </p>
        <p>
          ✅ Ви можете грати в{" "}
          <strong>{process.env.REACT_APP_FANTASY_TITLE}</strong> безкоштовно
          протягом 2 тижнів з моменту реєстрації. Після чого потрібно стати
          патроном{" "}
          <a href={patreonUrl} target="_blank" rel="noreferrer">
            каналу Фентезі Футбол{" "}
          </a>{" "}
          з місячним платежем $1 або більше.
        </p>
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-patch-question"></i>&nbsp;Як нараховуються бали?
        </h5>
        <p>
          ✅ Гравці набирають очки в залежності від власних дій і результатів
          їхніх команд. Для розраxунку очок ми використовуємо інформацію{" "}
          <a
            rel="noreferrer"
            target="_blank"
            href="https://www.transfermarkt.de/persha-liga/startseite/wettbewerb/UKR2"
          >
            веб-сайту transfermarkt.de
          </a>
        </p>
        <p>
          ✅ Якщо матч завершився технічною поразкою, очки не нараховуються за
          дії, які не відбулися на футбольному полі. Матч з точки зору
          фентезі-футболу вважається незіграним.
        </p>
        {isMobile ? (
          <Table striped size="sm" style={{ fontSize: "1.3rem" }}>
            <thead>
              <tr>
                <th>Правило</th>
                <th>Бали</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Зіграв менше 60 хвилин</td>
                <td>1</td>
              </tr>
              <tr>
                <td>Зіграв 60+ хвилин (без врахування доданого часу)</td>
                <td>2</td>
              </tr>
              <tr>
                <td>За гол голкіпера</td>
                <td>7</td>
              </tr>
              <tr>
                <td>За гол захисника</td>
                <td>6</td>
              </tr>
              <tr>
                <td>За гол півзахисника</td>
                <td>5</td>
              </tr>
              <tr>
                <td>За гол нападника</td>
                <td>4</td>
              </tr>
              <tr>
                <td>За гол голкіпера з пенальті</td>
                <td>5</td>
              </tr>
              <tr>
                <td>За гол захисника з пенальті</td>
                <td>4</td>
              </tr>
              <tr>
                <td>За гол півзахисника з пенальті</td>
                <td>3</td>
              </tr>
              <tr>
                <td>За гол нападника з пенальті</td>
                <td>2</td>
              </tr>
              <tr>
                <td>За гольовий асист голкіпера</td>
                <td>5</td>
              </tr>
              <tr>
                <td>За гольовий асист захисника</td>
                <td>4</td>
              </tr>
              <tr>
                <td>За гольовий асист півзахисника</td>
                <td>3</td>
              </tr>
              <tr>
                <td>За гольовий асист нападника</td>
                <td>2</td>
              </tr>
              <tr>
                <td>
                  За сухий матч команди голкіпера<sup>1</sup>
                </td>
                <td>5</td>
              </tr>
              <tr>
                <td>
                  За сухий матч команди захисника<sup>1</sup>
                </td>
                <td>4</td>
              </tr>
              <tr>
                <td>
                  За сухий матч команди півзахисника<sup>1</sup>
                </td>
                <td>2</td>
              </tr>
              <tr>
                <td>
                  За сухий матч команди нападника<sup>1</sup>
                </td>
                <td>1</td>
              </tr>
              <tr>
                <td>Не дозволив забити з пенальті</td>
                <td>4</td>
              </tr>
              <tr>
                <td>За нереалізований пенальті</td>
                <td>-2</td>
              </tr>
              <tr>
                <td>
                  За вольову перемогу (команда першою пропустила, але перемогла)
                  <sup>2</sup>
                </td>
                <td>1</td>
              </tr>
              <tr>
                <td>
                  За кожні забиті командою 2 голи для нападника або півзахисника
                  <sup>2</sup>
                </td>
                <td>1</td>
              </tr>
              <tr>
                <td>
                  За кожні пропущені командою 2 голи для голкіпера або захисника
                  <sup>2</sup>
                </td>
                <td>-1</td>
              </tr>
              <tr>
                <td>
                  За жовту картку<sup>3</sup>
                </td>
                <td>-1</td>
              </tr>
              <tr>
                <td>
                  За червону картку<sup>3</sup>
                </td>
                <td>-3</td>
              </tr>
              <tr>
                <td>За автогол</td>
                <td>-2</td>
              </tr>
            </tbody>
          </Table>
        ) : (
          <Table
            className="rules-table"
            striped
            size="sm"
            style={{ fontSize: "1.3rem" }}
          >
            <thead>
              <tr>
                <th style={{ textAlign: "left" }}>Правило</th>
                <th>
                  <Badge style={{ color: "#161616" }}>ГК</Badge>
                </th>
                <th>
                  <Badge style={{ color: "#161616" }}>ЗАХ</Badge>
                </th>
                <th>
                  <Badge style={{ color: "#161616" }}>ПІВ</Badge>
                </th>
                <th>
                  <Badge style={{ color: "#161616" }}>НАП</Badge>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Зіграв 60+ хвилин (без врахування доданого часу)</td>
                <td>2</td>
                <td>2</td>
                <td>2</td>
                <td>2</td>
              </tr>
              <tr>
                <td>Зіграв менше 60 хвилин</td>
                <td>1</td>
                <td>1</td>
                <td>1</td>
                <td>1</td>
              </tr>
              <tr>
                <td>Гол</td>
                <td>7</td>
                <td>6</td>
                <td>5</td>
                <td>4</td>
              </tr>
              <tr>
                <td>Гол з пенальті</td>
                <td>5</td>
                <td>4</td>
                <td>3</td>
                <td>2</td>
              </tr>
              <tr>
                <td>Не забив з пенальті</td>
                <td>-2</td>
                <td>-2</td>
                <td>-2</td>
                <td>-2</td>
              </tr>
              <tr>
                <td>Не дозволив забити з пенальті</td>
                <td>4</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>Автогол</td>
                <td>-2</td>
                <td>-2</td>
                <td>-2</td>
                <td>-2</td>
              </tr>
              <tr>
                <td>Асист</td>
                <td>5</td>
                <td>4</td>
                <td>3</td>
                <td>2</td>
              </tr>
              <tr>
                <td>
                  Сухий матч команди<sup>1</sup>
                </td>
                <td>5</td>
                <td>4</td>
                <td>2</td>
                <td>1</td>
              </tr>
              <tr>
                <td>
                  Кожні 2 пропущені командою м'ячі<sup>2</sup>
                </td>
                <td>-1</td>
                <td>-1</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>
                  Кожні 2 забиті командою м'ячі<sup>2</sup>
                </td>
                <td></td>
                <td></td>
                <td>1</td>
                <td>1</td>
              </tr>
              <tr>
                <td>
                  Вольова перемога<sup>2</sup>
                </td>
                <td>1</td>
                <td>1</td>
                <td>1</td>
                <td>1</td>
              </tr>

              <tr>
                <td>
                  Жовта картка<sup>3</sup>
                </td>
                <td>-1</td>
                <td>-1</td>
                <td>-1</td>
                <td>-1</td>
              </tr>
              <tr>
                <td>
                  Червона картка<sup>3</sup>
                </td>
                <td>-3</td>
                <td>-3</td>
                <td>-3</td>
                <td>-3</td>
              </tr>
            </tbody>
          </Table>
        )}
        <p>
          <sup>1</sup> - сухий матч зараховується футболісту, якщо він провів на
          футбольному полі мінімум 60 хвилин (без врахування доданого часу) та
          його команда не пропустила гол у матчі.
        </p>
        <p>
          <sup>2</sup> - футболіст має знаходитися на полі мінімум 60 хвилин.
        </p>
        <p>
          <sup>3</sup> - якщо футболіст отримує дві жовті та автоматичну
          червону, то рахуватиметься тільки червона картка.
        </p>
        <h5 style={{ marginBottom: 12 }}>
          <i className="bi bi-patch-question"></i>&nbsp;Що ще треба знати?{" "}
        </h5>
        <p>
          ✅ Ви можете створити власну приватну лігу і змагатися з тими, кому
          передасте посилання на неї.
        </p>
        <p>
          ✅ Нарахування очок та оновлення рейтингів відбувається протягом 12
          годин після завершення поточного туру змагань.
        </p>
        <p>
          ✅ Очки вашої команди нараховуються в 4 рейтингах – загальний,
          місячний, туру і ліга вболівальників вашого клубу. Змінити улюблений
          клуб можна лише один раз протягом місяця з моменту реєстрації у
          турнірі.{" "}
        </p>
        <p>
          ✅ Переможець сезону отримає річну підписку на ОТТ платформу{" "}
          <strong>Setanta Sports</strong>.
        </p>
        <p>
          ✅ За умови рівності очок, для визначення переможця рейтингів
          застосовуються додаткові показники. Перевагу отримують учасники, у
          яких спрацювала менша кількість автозамін. Якщо ж і цей показник
          рівний, то вище будуть учасники, які набрали більшу кількість очок без
          врахування подвоєння очок капітана. У випадку, коли додаткові
          показники не дозволяють визначити переможця, він визначатиметься за
          допомогою рандомайзера.
        </p>
        <p>
          ✅ Підпишіться на{" "}
          <a
            href={process.env.REACT_APP_TELEGRAM_CHANNEL_LINK}
            target="_blank"
            rel="noreferrer"
          >
            офіційний канал{" "}
            <strong>{process.env.REACT_APP_FANTASY_TITLE}</strong>
          </a>{" "}
          – там ми будемо нагадувати зробити зміни в складі перед стартом
          кожного туру, повідомляти про важливі новини і відповідати на ваші
          питання/зауваження.
        </p>
      </div>
    </Page>
  );
};

export default Rules;
